import { getPageCluster } from '@shared/domain/PageCluster.ts';
import type { FrontendTrackingLabels } from '@shared/tracking/TrackingLabels';

/*                                                                                              */
export function frontendPageViewTracking(historic: boolean): FrontendTrackingLabels {
    const pageCluster = getPageCluster() || 'UNKNOWN';

    const pageViewTracking: FrontendTrackingLabels = {
        san_ListEventType: 'tilelistview',
        ot_PageCluster: pageCluster,
    };

    if (historic) pageViewTracking.san_Interaction = 'browser_navigation';

    return pageViewTracking;
}
